import * as React from 'react';
import ThumbnailFile from '../../../../components/views/mx/thumbnail/ThumbnailFile';
import {VersionFileState} from '../../types/types';
import {PDF_EXTENSION, PDF_MIME_TYPE} from '../../../../../common/constants/MimeTypeConstants';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import DropZone from '../../../../../common/components/dropzone/DropZone';
import {MAX_FILE_SIZE} from '../../../../constants/AttachmentContants';
import {scrollToUtil} from '../../../../../common/utils/GeneralUtils';
import SelectSearchComponent from '../../../../../common/components/SelectSearchComponent';
import {FILES_SECTION} from '../../constants/LabelConstants';
import {AttachmentUploadFilesDispatchProps, AttachmentUploadFilesStateProps} from '../../types/containers';
import {FilesUploadDataState} from '../../types/components';
import {OTHER_TYPE} from '../../../../../common/constants/FileTypeConstants';

class AttachmentUploadFilesView extends React.Component<AttachmentUploadFilesStateProps
    & AttachmentUploadFilesDispatchProps, FilesUploadDataState> {

    constructor(props) {
        super(props);
        this.state = {
            showErrors: true
        };
    }

    onPressUploadFiles = () => {
        this.setState({showErrors: true}, this.checkData);
    }

    getNotUploadedFiles = files => files.filter(item => !item.isUploaded);

    checkData = () => {
        const {files, documentTypeSelected} = this.props;
        const noUploadedFiles = this.getNotUploadedFiles(files);
        const hasNotError = this.formHasNotError(noUploadedFiles, documentTypeSelected);
        if (hasNotError) {
            return this.props.onPressUploadFiles(noUploadedFiles);
        }
        const hasDocuments = !!documentTypeSelected.value;
        if (!hasDocuments) {
            this.props.onChangeDocumentType(this.props.documentTypeSelected.value,
                FILES_SECTION.REQUIRED_DOCUMENT_TYPE_MESSAGE);
        }
        if (noUploadedFiles.length === 0) {
            this.props.onDropFiles(noUploadedFiles, FILES_SECTION.REQUIRED_FILE_MESSAGE);
        }
    }

    formHasNotError = (files, documentTypeSelected) => files.length > 0 && !!documentTypeSelected.value
        && !!documentTypeSelected.value.id

    onCancel = () => this.props.onCancel();
    onPressCreateVersion = () => this.props.onPressCreateVersion();

    getFileToCompare = (mimeType, size, lastModified) => ({mimeType, size, lastModified});

    isDuplicatedFile = (obj1, obj2) => {
        const fs = this.getFileToCompare(obj1.mimeType, obj1.size, obj1.lastModified);
        const fs1 = this.getFileToCompare(obj2.type, obj2.size, obj2.lastModified);

        return JSON.stringify(fs) === JSON.stringify(fs1);
    }

    removeDuplicatedFile = (selectFiles, files) => {
        const newFiles = [];
        let isDuplicated = false;
        files.forEach((item) => {
            isDuplicated = false;
            selectFiles.forEach((item2) => {
                if (this.isDuplicatedFile(item, item2)) {
                    isDuplicated = true;
                    return;
                }
            });
            if (!isDuplicated) newFiles.push(item);
            if (newFiles.length === files.length) return;
        });
        return newFiles;
    }

    onDropFile = (files, error) => {
        const selectFiles = this.props.files;
        const newFiles = selectFiles.length > 0 ? this.removeDuplicatedFile(selectFiles, files) : files;
        const fileError = newFiles.length === files.length ? error : FILES_SECTION.REPEATED_FILE_MESSAGE;
        this.props.onDropFiles(newFiles, fileError);
    }

    showFiles = (files, isAutogenerated) => {
        return files.map((item, index) =>
            <ThumbnailFile key={index} file={item} showDeleteOption={!isAutogenerated}
                           onDelete={this.props.onDeleteFile}/>
        ).reverse();
    }

    generateThumbnailUrl = (item: VersionFileState) => {
        if (item.mimeType === PDF_MIME_TYPE || item.url.indexOf(PDF_EXTENSION) >= 0) {
            return AssetsManager('/assets/images/common/pdf-icon-normal.svg');
        }
        return item.urlCompress;
    }

    iconFolder = (openTree) => {
        return openTree ?
            AssetsManager('/assets/images/common/folder-open-select-icon.svg') :
            AssetsManager('/assets/images/common/folder-close-normal-icon.svg');
    }

    render() {
        const {
            documentTypes, documentTypeSelected,
            onChangeDocumentType, files, formType, versions, canUploadMoreFiles, canUploadMultipleFiles
        } = this.props;
        const {showErrors} = this.state;
        const noUploadedFiles = this.getNotUploadedFiles(files);
        const formHasNotError = this.formHasNotError(noUploadedFiles, documentTypeSelected);
        const btnStyle = 'btn btn-link btn-form border-0 h-100 pb-2';
        const hasFilesUploaded = files.filter(item => item.isUploaded).length > 0;

        const isModalForm: boolean = formType === FILES_SECTION.MODAL_FORM_TYPE;

        const selectDocument = !!documentTypeSelected.value ? {
            ...documentTypeSelected.value, value: documentTypeSelected.value.label
        } : null;
        const isAutogenerated: boolean = !!selectDocument && selectDocument.autogenerated;
        const allowMultipleFiles = selectDocument && selectDocument.id !== OTHER_TYPE;
        return (
            <div className="col-12 px-0 pt-2 pb-0">
                {!isModalForm && !!selectDocument && <div className="row">
                    <div className="col">
                        <h3 className="text-raleway text-secondary-lighten-1 text-ellipsis">
                            {selectDocument.label}
                        </h3>
                    </div>
                </div>}
                {!isModalForm && files.filter(item => item.isUploaded).length > 0 && <div className="row">
                    <div className="col">
                        <div className="pb-4 pt-2 px-3 text-secondary-lighten-1">
                            Última modificación:
                            {
                                files.reduce((total, item) =>
                                total.lastModified > item.lastModified ? total : item).lastModifiedToDisplay || ' Ahora'
                            }
                        </div>
                    </div>
                </div>}
                <div className="border-top-file"/>
                <div className="row doc-container">
                    <div className="col">
                        {isModalForm && <div className="row">
                            <div className="col">
                                <p className="regular-text">{FILES_SECTION.UPLOAD_FILES_LABEL_1}</p>
                                <SelectSearchComponent
                                    id="documentTypes"
                                    customClass="no-min-height"
                                    required={true}
                                    filter={true}
                                    hasError={showErrors}
                                    labelError={documentTypeSelected.error}
                                    placeholder="Selecciona el tipo de documento"
                                    label={FILES_SECTION.UPLOAD_DOCUMENT_TYPE_LABEL}
                                    data={documentTypes.filter(item => !item.autogenerated)
                                        .map(item => ({...item, value: item.label}))
                                        .sort((a, b) => a.label.localeCompare(b.label))}
                                    value={selectDocument}
                                    onChange={onChangeDocumentType}/>
                            </div>
                        </div>
                        }
                        {!!selectDocument && isModalForm && documentTypeSelected.value.info !== '' &&
                        <div className="row">
                            <div className="col">
                                <div className="row border-attention m-0 py-3 mb-4">
                                    <div className="col-1 p-0 text-center">
                                        <img src={AssetsManager('/assets/images/common/attention-icon.svg')}
                                             alt="Attention"/>
                                    </div>
                                    <div className="col-11 p-0 input-text-enabled">
                                        {documentTypeSelected.value.info}
                                    </div>
                                </div>
                            </div>
                        </div>}
                        {!canUploadMoreFiles && <div className="row">
                            <div className="col">
                                <div className="row border-attention m-0 py-3 mb-4">
                                    <div className="col-1 p-0 text-center">
                                        <img src={AssetsManager('/assets/images/common/attention-icon.svg')}
                                             alt="Attention"/>
                                    </div>
                                    <div className="col-11 p-0 input-text-enabled">
                                        {FILES_SECTION.CANT_UPLOAD_MORE_FILES_INFO}
                                    </div>
                                </div>
                            </div>
                        </div>}
                        {!isAutogenerated && canUploadMoreFiles && canUploadMultipleFiles && <div className="row">
                            <div className="col">
                                {isModalForm && <p className="regular-text">{FILES_SECTION.UPLOAD_FILES_LABEL_2}</p>}
                                <DropZone id="dropzone"
                                          label={FILES_SECTION.UPLOAD_FILES_INFO_2}
                                          maxSize={MAX_FILE_SIZE}
                                          labelButton={FILES_SECTION.UPLOAD_FILES_SELECT_LABEL}
                                          hasError={showErrors}
                                          labelError={this.props.filesError}
                                          onDrop={this.onDropFile}/>
                            </div>
                        </div>}
                        <div className="row">
                            <div className="col d-flex align-items-center wrapper-selected-files-section">
                                {!!files && files.length > 4 && <div className="arrow left">
                                    <img src={
                                        AssetsManager('/assets/images/common/arrow-slide-left.svg')
                                    } alt="left" onClick={() =>
                                        scrollToUtil(document.getElementById('scroll_section'), false)}/>
                                </div>}
                                {!!files && files.length > 4 && <div className="arrow right">
                                    <img src={
                                        AssetsManager('/assets/images/common/arrow-slide-right.svg')
                                    } alt="right" onClick={() =>
                                        scrollToUtil(document.getElementById('scroll_section'), true)}/>
                                </div>}
                                <div id="scroll_section" className="content-selected-files-section pb-4">
                                    <div id="selected-files-section">
                                        {this.showFiles(files, isAutogenerated)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {versions.length ? <div className="row">
                            <div className="col">
                                <div className="row">
                                    <div className="col">
                                        <div className="header-bar mb-3">{FILES_SECTION.VERSION_TITLE}</div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        {versions.map((version, index) =>
                                            <ul className={`tree-version ${version.openTree ? 'open' : ''}`}
                                                onClick={() => version.toggleTree()} key={index}>
                                                <img src={this.iconFolder(version.openTree)} alt="folder"/>
                                                <li className="item-tree-version">{version.name}</li>
                                                {version.openTree && <ul className="sub-tree-version">
                                                    {version.documentGroups.map((versionFiles, index) =>
                                                        <React.Fragment key={index}>
                                                            <img className="rounded float-left mt-2"
                                                                 src={this.generateThumbnailUrl(versionFiles)}
                                                                 alt="thumbnail" width="32px" height="32px"/>
                                                            <li className="item-sub-tree-version">
                                                                <a href={versionFiles.url} target="_blank">
                                                                    <span>{versionFiles.name}</span>
                                                                </a>
                                                                <span>{versionFiles.uploadDate.displayValue}</span>
                                                            </li>
                                                        </React.Fragment>
                                                    )}
                                                </ul>}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div> : null}
                    </div>
                </div>
                {!isAutogenerated && <div className="col-12 d-flex pt-3 px-0 border-top">
                    <div className="d-flex justify-content-start flex-grow-1">
                        {hasFilesUploaded && canUploadMoreFiles && <a className={`${btnStyle} text-secondary-lighten-5 pl-0`}
                                                onClick={this.onPressCreateVersion}>
                            {isModalForm ? FILES_SECTION.CREATE_VERSION_LABEL :
                                FILES_SECTION.CREATE_VERSION_LABEL_2}</a>}
                    </div>
                    <div className="d-flex justify-content-end">
                        {isModalForm && <a className={`${btnStyle} text-secondary-lighten-5`}
                                           onClick={this.onCancel}>{FILES_SECTION.CANCEL_LABEL}</a>}
                        {canUploadMoreFiles && <a id="saveBtn"
                           className={formHasNotError ? `${btnStyle} text-primary pr-0` :
                               `${btnStyle} text-secondary-lighten-5 pr-0`}
                           onClick={this.onPressUploadFiles}>{FILES_SECTION.UPLOAD_FILE_LABEL}</a>}
                    </div>
                </div>}
            </div>
        );
    }
}

export default AttachmentUploadFilesView;
